module.exports = __webpack_public_path__ + "static/images/status-valid.3086OZ_.svg";